import type { RelativeRange, RelativeRangeType } from "app/pages/sales-intelligence/types/range";

import type { FilterCategory } from "../../types/category";

// TODO Uses leads namespace for now — will migrate to si.filters.search.* post-release
const advancedFilteringI18nKeys = {
    searchKeyword: (keyword: string) => `si.lead_gen_filters.search.keywords.${keyword}`,

    category: (category: FilterCategory) => `si.lead_gen_filters.category.${category}.label`,

    categoryViewMoreTooltip: (category: FilterCategory) =>
        `si.filter-panel.category-view-more.${category}.tooltip.text`,

    onlyNewMatchesCheckboxLabel: "si.company_search.only_new_matches_checkbox.label",

    cannotUnpinActiveFilterTooltip: "si.lead_gen_filters.pin.cannot_unpin_active_filter",

    relativeDateRange: {
        defaultLabel: "si.find_apps.filters.updateDate.dropdown-label",
        placeholder: "si.find_apps.filters.updateDate.dropdown-placeholder",
        option: (optionKey: RelativeRangeType | RelativeRange) => `si.find_apps.filters.updateDate.option.${optionKey}`,
        optionChip: (optionKey: RelativeRangeType | RelativeRange) =>
            `si.find_apps.filters.updateDate.option.${optionKey}.chip`,
    },

    expandedFilters: {
        title: "si.filters.expanded.title",
        subTitle: "si.filters.expanded.subtitle",
    },

    groupDialog: {
        // Label above the field picker (ticket: "Filter" → "Select a CRM field") + its empty placeholder.
        filterLabel: "si.lead_gen_filters.group.dialog.select_field",
        fieldPlaceholder: "si.lead_gen_filters.group.dialog.field_placeholder",
        // The centered "+ Add condition" button (in the panel card) that opens the modal.
        addCondition: "si.lead_gen_filters.group.dialog.add_condition",
        emptyDescription: "si.lead_gen_filters.group.dialog.empty_description",
        apply: "common.apply",
        cancel: "si.common.button.cancel",
    },
} as const;

export default advancedFilteringI18nKeys;
